
export const plugins = []

export const strict = false
